(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99],{

/***/ 35866:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[name]",
      function () {
        return __webpack_require__(91188);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76422);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52823);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1098);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50657);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);


/* eslint-disable @next/next/no-img-element */ 




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// import { isPC } from '../utils/checkDevice'
// import { useWindowSize } from '../hooks/useWindowSize'
swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Zoom */ .LG,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Lazy */ .oM,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Keyboard */ .N1
]);
// import Image from './Image'
var photoSwiperConfig = {
    autoplay: false,
    loop: true,
    zoom: true,
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3
    },
    centeredSlides: true,
    observer: true,
    spaceBetween: 0
};
var PhotoSwiper = function(_param) {
    var images = _param.images, _open = _param.open, open = _open === void 0 ? false : _open, _initialSlide = _param.initialSlide, initialSlide = _initialSlide === void 0 ? 1 : _initialSlide, _className = _param.className, className = _className === void 0 ? '' : _className, onOpenChange = _param.onOpenChange, onSlideChange = _param.onSlideChange, _showPagination = _param.showPagination, showPagination = _showPagination === void 0 ? true : _showPagination, others = _objectWithoutProperties(_param, [
        "images",
        "open",
        "initialSlide",
        "className",
        "onOpenChange",
        "onSlideChange",
        "showPagination"
    ]);
    var config = _objectSpread({
    }, photoSwiperConfig, others);
    var lazy = config.lazy, zoom = config.zoom;
    // const ispc = useMemo(() => isPC(), [])
    // const { upSm } = useWindowSize()
    var position = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({
    });
    var count = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(0);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialSlide), /*#__PURE__*/ swiperIndex = ref[0], setSwiperIndex = ref[1];
    var handleSlideChange = function(e) {
        setSwiperIndex(e.realIndex);
        onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(e.realIndex);
    };
    // swiper移动端不返回events，伐了
    var handleTouchStart = function(ev) {
        position.current = {
            ev: ev
        };
    };
    var handleTouchEnd = function(ev) {
        var _ev = position.current.ev, clientX = _ev.clientX, clientY = _ev.clientY;
        var clientX2 = ev.clientX, clientY2 = ev.clientY;
        count.current += 1;
        setTimeout(function() {
            if (count.current === 1 && Math.abs(clientX - clientX2) < 10 && Math.abs(clientY - clientY2) < 10) {
                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
            }
            count.current = 0;
            window.document.body.style.pointerEvents = 'none';
            setTimeout(// eslint-disable-next-line no-return-assign
            function() {
                return window.document.body.style.pointerEvents = 'unset';
            }, 300);
        }, 300);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "photo-wrapper-box",
                open: open,
                fullScreen: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-7563a2bab326c32b" + " " + "photo-wrapper absolute top-0 left-0 z-10 w-full h-full flex justify-center items-center bg-black ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .t, _objectSpread({
                        }, config, {
                            initialSlide: initialSlide,
                            keyboard: {
                                enabled: true
                            },
                            onSlideChange: handleSlideChange,
                            onPointerDown: function(ev) {
                                return handleTouchStart(ev);
                            },
                            onPointerUp: function(ev) {
                                return handleTouchEnd(ev);
                            },
                            className: "w-full",
                            children: images.map(function(item) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o, {
                                    className: "w-full h-screen",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        style: {
                                            height: '100vh'
                                        },
                                        onPointerDown: function(e) {
                                            return handleTouchStart(e.nativeEvent);
                                        },
                                        onPointerUp: function(e) {
                                            return handleTouchEnd(e.nativeEvent);
                                        },
                                        className: "jsx-7563a2bab326c32b" + " " + "flex w-full justify-center items-center h-screen relative ".concat(zoom ? 'swiper-zoom-container' : ''),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                "data-src": item,
                                                src: !lazy ? item : '',
                                                height: "auto",
                                                style: {
                                                    maxWidth: '580px'
                                                },
                                                alt: "",
                                                className: "jsx-7563a2bab326c32b" + " " + "block border-none w-full ".concat(lazy ? 'swiper-lazy' : '')
                                            }),
                                            lazy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-7563a2bab326c32b" + " " + "swiper-lazy-preloader swiper-lazy-preloader-white"
                                            })
                                        ]
                                    })
                                }, item);
                            })
                        })),
                        showPagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-7563a2bab326c32b" + " " + "photo-text absolute bottom-0 z-20 flex justify-center text-white mb-11 textShadow",
                            children: [
                                swiperIndex + 1,
                                " / ",
                                images.length
                            ]
                        })
                    ]
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__["default"], {
                id: "7563a2bab326c32b",
                children: ".textShadow.jsx-7563a2bab326c32b {text-shadow:0px 6px 8px rgba(0, 0, 0, 0.48)}"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PhotoSwiper);


/***/ }),

/***/ 55289:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var queryPack = function(info) {
    var query = '';
    // eslint-disable-next-line array-callback-return
    Object.keys(info).map(function(k) {
        query += "".concat(k, "=").concat(encodeURIComponent(info[k]), "&");
    });
    return query.substr(0, query.length - 1);
};
var LotteryReport = function(action) {
    var lotteryApiAddress = "https://service-1g6nhy8g-1304173006.usw.apigw.tencentcs.com/release";
    var email = localStorage.getItem('lottery_email');
    var query = queryPack({
        email: email,
        action: action
    });
    if (action && email && !localStorage.getItem(action)) {
        fetch("".concat(lotteryApiAddress, "/shopify/lottery/behavior?").concat(query)).then(function(response) {
            return response.json();
        }).then(function() {
            // eslint-disable-next-line no-console
            localStorage.setItem(action, 'OK');
        }).catch(function(err) {
            // eslint-disable-next-line no-console
            console.log(err);
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (LotteryReport);


/***/ }),

/***/ 89096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xn": function() { return /* binding */ CollectionSkeleton; },
/* harmony export */   "LR": function() { return /* binding */ PagesSkeleton; },
/* harmony export */   "NB": function() { return /* binding */ ProductSkeleton; }
/* harmony export */ });
/* unused harmony export ProductItem */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74782);

/* eslint-disable import/prefer-default-export */ 

var ProductItem = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        animate: false,
        viewBox: "0 0 330 510",
        backgroundColor: "#f3f3f3",
        foregroundColor: "#f3f3f3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: "0",
                width: "330",
                height: "440"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: 450,
                width: "330",
                height: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: 450 + 18 + 10,
                width: "150",
                height: "26"
            })
        ]
    });
};
var CollectionSkeleton = function(param) {
    var className = param.className, _count = param.count, count = _count === void 0 ? 8 : _count;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-2 md:grid-cols-4 -mx-2 ".concat(className),
        children: Array(count).fill(0).map(function(_, idx) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-2 mb-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductItem, {
                })
            }, idx);
        })
    });
};
var PagesSkeleton = function(param) {
    var _isPC = param.isPC, isPC = _isPC === void 0 ? false : _isPC;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        rtl: true,
        speed: 2,
        className: "w-full h-full",
        viewBox: "0 0 ".concat(isPC ? '1065 1008' : '686 850'),
        backgroundColor: "#f3f3f3",
        children: isPC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 0 64 h 1065 v 16 H 0 z M 0 448 h 1065 v 16 H 0 z M 0 832 h 1065 v 16 H 0 z M 0 152 h 1065 v 16 H 0 z M 0 536 h 1065 v 16 H 0 z M 0 920 h 1065 v 16 H 0 z M 0 88 h 1065 v 16 H 0 z M 0 472 h 1065 v 16 H 0 z M 0 856 h 1065 v 16 H 0 z M 0 176 h 1065 v 16 H 0 z M 0 560 h 1065 v 16 H 0 z M 0 944 h 1065 v 16 H 0 z M 0 200 h 1065 v 16 H 0 z M 0 584 h 1065 v 16 H 0 z M 0 968 h 1065 v 16 H 0 z M 0 264 h 1065 v 160 H 0 z M 0 648 h 1065 v 160 H 0 z M 0 112 h 817 v 16 H 0 z M 0 496 h 817 v 16 H 0 z M 0 880 h 817 v 16 H 0 z M 0 224 h 560 v 16 H 0 z M 0 608 h 560 v 16 H 0 z M 0 992 h 560 v 16 H 0 z M 232 0 h 600 v 32 H 232 z"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 136 0 h 414 v 56 H 136 z M 0 100 h 686 v 42 H 0 z M 0 412 h 349 v 42 H 0 z M 0 578 h 349 v 42 H 0 z M 0 163 h 686 v 209 H 0 z M 0 475 h 686 v 19 H 0 z M 0 515 h 686 v 19 H 0 z M 0 641 h 686 v 209 H 0 z"
        })
    });
};
var ProductSkeleton = function(param) {
    var _isPC = param.isPC, isPC = _isPC === void 0 ? false : _isPC;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        // speed={2}
        animate: false,
        className: "w-full h-full",
        viewBox: "0 0 ".concat(isPC ? '1408 911' : '750 1316'),
        backgroundColor: "#f3f3f3",
        foregroundColor: "#f3f3f3",
        children: isPC ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 94 0 h 685 v 911 H 94 z M 0 114 h 71 v 96 H 0 z M 0 226 h 71 v 96 H 0 z M 0 338 h 71 v 96 H 0 z M 0 0 h 71 v 96 H 0 z M 854 14 h 552 v 24 H 854 z M 854 53 h 165 v 24 H 854 z M 854 94 h 165 v 24 H 854 z M 854 181 h 165 v 24 H 854 z M 1294 181 h 112 v 24 h -112 z M 854 124 h 370 v 40 H 854 z M 854 210 h 552 v 36 H 854 z M 854 258 h 552 v 62 H 854 z M 854 353 h 552 v 152 H 854 z M 854 530 h 552 v 44 H 854 z M 854 592 h 552 v 148 H 854 z M 854 754 h 552 v 110 H 854 z"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 0 0 h 82 v 773 H 0 z M 90 0 h 570 v 773 H 90 z M 668 0 h 82 v 773 h -82 z M 24 793 h 450 v 40 H 24 z M 684 793 h 42 v 40 h -42 z M 24 853 h 179 v 52 H 24 z M 24 932 h 179 v 28 H 24 z M 493 862 h 233 v 28 H 493 z M 549 1067 h 177 v 28 H 549 z M 24 1067 h 104 v 28 H 24 z M 24 975 h 570 v 64 H 24 z M 24 1111 h 702 v 64 H 24 z M 24 1182 h 702 v 134 H 24 z"
        })
    });
};


/***/ }),

/***/ 91188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(92021);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(52823);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/PhotoSwiper.tsx
var PhotoSwiper = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(15567);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(37336);
;// CONCATENATED MODULE: ./src/components/products/ProductsSwiper.tsx

/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ 





// import { AiFillCloseCircle } from 'react-icons/ai'


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var productPageSensorMod = function() {
    return __webpack_require__.e(/* import() */ 506).then(__webpack_require__.bind(__webpack_require__, 12506));
};
var productPageSensor;
// 小屏
var config = {
    autoplay: false,
    slidesPerView: 'auto',
    spaceBetween: 4,
    centeredSlides: true,
    loop: true,
    observer: true,
    observeParents: true
};
// 大屏
var config2 = {
    autoplay: false,
    spaceBetween: 0,
    centeredSlides: true,
    slidesPerView: 'auto',
    loop: true
};
var ProductsSwiper = function(param) {
    var _initialSlide = param.initialSlide, initialSlide = _initialSlide === void 0 ? 0 : _initialSlide, data = param.data;
    var ref = (0,react.useState)(initialSlide), curIndex = ref[0], setCurIndex = ref[1];
    var ref1 = (0,react.useState)(), isMax = ref1[0], setIsMax = ref1[1];
    var ref2 = (0,react.useState)(), swiperConfig = ref2[0], setSwiperConfig = ref2[1];
    var smallSlider = (0,react.useRef)({
    });
    var ref3 = (0,react.useState)({
    }), swiperObj = ref3[0], setSwiperObj = ref3[1];
    var ref4 = (0,react.useState)(false), open = ref4[0], setOpen = ref4[1];
    var ref5 = (0,react.useState)(data.images.edges), images = ref5[0], setImages = ref5[1];
    // 获取视差宽度与swiper参数
    var getClientWidth = function() {
        return (document === null || document === void 0 ? void 0 : document.body.clientWidth) >= 768;
    };
    var getSwiperConfig = function() {
        if (getClientWidth()) {
            return config2;
        }
        return config;
    };
    var onSlideChange = function(index) {
        setCurIndex(index);
    };
    var smallSlideTo = function(idx) {
        smallSlider.current.scrollTop = idx * 112 - 60 > 0 ? idx * 112 - 60 : 0;
    };
    var slideTo = function(idx) {
        if (!swiperObj && idx <= images.length) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        swiperObj && swiperObj.slideTo && (swiperObj === null || swiperObj === void 0 ? void 0 : swiperObj.slideTo(idx));
        smallSlideTo(idx);
    };
    var onAsyncSlideChange = function(index) {
        setCurIndex(index);
        slideTo(index);
    };
    var imageList = images.map(function(item) {
        return item.node.src || item.node.originalSrc;
    });
    var debounceSetOpen = debounce_default()(function(e) {
        setOpen(e);
    }, 200, {
        trailing: true
    });
    var openPriview = function(idx) {
        setCurIndex(idx);
        debounceSetOpen(true) // 节流一下
        ;
        productPageSensor === null || productPageSensor === void 0 ? void 0 : productPageSensor.BigPictureClick(data);
    };
    var setSwiperConfigs = function() {
        setIsMax(getClientWidth());
        setSwiperConfig(getSwiperConfig());
    };
    var resetSwiper = function() {
        setSwiperConfigs();
        swiperObj === null || swiperObj === void 0 ? void 0 : swiperObj.update(true);
    };
    var throttleResetSwiper = throttle_default()(resetSwiper, 2000) // 节流一下
    ;
    (0,react.useEffect)(function() {
        setSwiperConfigs();
        setImages(data.images.edges);
    }, [
        data
    ]);
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if ( true && data) {
            productPageSensorMod().then(function(mod) {
                productPageSensor = mod.default;
                productPageSensor === null || productPageSensor === void 0 ? void 0 : productPageSensor.resetHasBigPictureClick();
            });
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        if (initialSlide !== null) {
            slideTo(initialSlide);
        }
    }, [
        initialSlide
    ]);
    return images && images.length > 0 && swiperConfig ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex items-stretch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden sm:hidden md:block pr-5 relative w-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 h-full overflow-y-auto overflow-x-hidden nobar",
                    ref: smallSlider,
                    children: images.map(function(i, idx) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: '75px',
                                height: '100px'
                            },
                            className: "cursor-pointer relative border-2 border-black ".concat(idx === curIndex ? 'border-gray' : 'border-white', " ").concat(idx === images.length - 1 ? '' : 'mb-3'),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.C, {
                                src: i.node.src || i.node.originalSrc,
                                alt: i.title || '',
                                layout: "fill",
                                onClick: function() {
                                    return slideTo(idx);
                                }
                            })
                        }, i.node.src);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1 w-0 md:mr-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.t, _objectSpread({
                }, swiperConfig, {
                    initialSlide: curIndex,
                    onSlideChange: function(e) {
                        return onSlideChange(e === null || e === void 0 ? void 0 : e.realIndex);
                    },
                    onSwiper: function(swiper) {
                        return setSwiperObj(swiper);
                    },
                    onResize: throttleResetSwiper,
                    className: "w-full",
                    children: [
                        images.map(function(i, idx) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                style: {
                                    width: "".concat(isMax ? '100' : 0.76 * 100, "%"),
                                    // maxWidth: `${isMax ? '100' : 0.76 * 100}%`,
                                    height: '0',
                                    paddingBottom: "".concat(isMax ? 133 : 103, "%")
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.C, {
                                    src: i.node.src || i.node.originalSrc,
                                    alt: i.title || '',
                                    layout: "fill",
                                    onClick: function() {
                                        return openPriview(idx);
                                    },
                                    className: "cursor-zoom imgref"
                                })
                            }, i.node.src);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-50 md:hidden absolute bottom-4 left-1/2 transform -translate-x-1/2 text-gray-50 text-xs bg-gray-900 bg-opacity-60 w-10 min-w-min flex justify-center items-center rounded-lg h-4",
                            children: [
                                curIndex + 1,
                                "/",
                                images === null || images === void 0 ? void 0 : images.length
                            ]
                        })
                    ]
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoSwiper/* default */.Z, {
                images: imageList,
                open: open,
                initialSlide: curIndex,
                onSlideChange: onAsyncSlideChange,
                onOpenChange: function() {
                    setOpen(false);
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    });
};
/* harmony default export */ var products_ProductsSwiper = (ProductsSwiper);

// EXTERNAL MODULE: ../../node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(77245);
// EXTERNAL MODULE: ./src/utils/constants/index.ts
var constants = __webpack_require__(52372);
;// CONCATENATED MODULE: ./src/components/products/ProductsSelect.tsx


/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ 

// import cheerio from 'cheerio'



function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function ProductsSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
// tie-dye-long-casual-sweatshirt
var ProductSelect = function(param2) {
    var data = param2.data, _showSizeGuide = param2.showSizeGuide, showSizeGuide = _showSizeGuide === void 0 ? true : _showSizeGuide, onSelectChange = param2.onSelectChange, onOpenSizeGuide = param2.onOpenSizeGuide, errorMsg = param2.errorMsg;
    var handleVariants = /** 处理 */ function handleVariants() {
        var options = get_default()(data, 'options[0].values', []);
        var variant = get_default()(data, 'variants.edges');
        var result = [];
        options.forEach(function(item) {
            result.push(variant.filter(function(item2) {
                return item2.node.selectedOptions[0].value === item;
            }));
        });
        return result.flat();
    };
    var ref9, ref1, ref2;
    var variants = handleVariants();
    var router = (0,next_router.useRouter)();
    var variantid = router.query.variant // 设置id
    ;
    var sku = router.query.sku;
    var ref3 = (0,react.useState)([]), sizeItem = ref3[0], setSizeItem = ref3[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref4 = (0,react.useState)(), curSelectInfo = ref4[0], setCurSelectInfo = ref4[1];
    var ref5 = (0,react.useState)([]), classifyList = ref5[0], setClassifyList = ref5[1];
    var ref6 = (0,react.useState)(false), hasSizeGuide = ref6[0], setHasSizeGuide = ref6[1];
    var ref7 = (0,react.useState)([]), curIndex = ref7[0], setCurIndex = ref7[1];
    var ref8 // 当前组合颜色与size 用于做渲染
     = (0,react.useState)({
        color: [],
        size: []
    }), curDataList = ref8[0], setCurDataList = ref8[1];
    var isNormalData = (0,react.useMemo)(function() {
        var options = get_default()(data, 'options');
        if (Array.isArray(options)) {
            options = options.filter(function(item) {
                return [
                    'color',
                    'size'
                ].includes(item === null || item === void 0 ? void 0 : item.name.toLocaleLowerCase());
            });
            return options.length > 0;
        }
        return false;
    }, [
        data === null || data === void 0 ? void 0 : data.options
    ]);
    // 分类颜色 =》 通过尺寸
    var handleClassifyColor = function(name) {
        var result = [];
        variants === null || variants === void 0 ? void 0 : variants.filter(function(item) {
            return item.node.selectedOptions[1].value === name;
        }).forEach(function(item) {
            result.push(item.node.selectedOptions[0].value);
        });
        return result;
    };
    // 分类尺寸 =》 通过颜色
    var handleClassifySize = function(name) {
        var result = [];
        variants === null || variants === void 0 ? void 0 : variants.filter(function(item) {
            return item.node.selectedOptions[0].value === name;
        }).forEach(function(item) {
            result.push(item.node.selectedOptions[1].value);
        });
        return result;
    };
    // 获取分类全部
    var handleClassifyAll = function(color, size) {
        return {
            size: handleClassifySize(color),
            color: handleClassifyColor(size)
        };
    };
    // 一开始处理数
    var handleClassify = function() {
        var colors = get_default()(data, 'options[0].values', 0);
        var sizes = get_default()(data, 'options[1].values', 0);
        var max = Math.max(colors.length, sizes.length);
        var result = [];
        for(var i = 0; i < variants.length; i += max){
            var dealResult = variants.slice(i, i + max);
            var isempty = dealResult.every(function(item) {
                return !item.node.availableForSale;
            });
            result.push({
                result: dealResult,
                isempty: isempty,
                name: dealResult[0].node.selectedOptions[0].value
            });
        }
        setClassifyList(result);
    };
    // 设置有库存的样式，获取组合
    // 尺寸对应颜色
    var handleBtnDisabled = function(param, param1) {
        var cidx = param === void 0 ? 0 : param, sidx = param1 === void 0 ? 0 : param1;
        var sname = curDataList.size[sidx];
        var cname = curDataList.color[cidx];
        var result = variants.find(function(item) {
            return item.node.selectedOptions[0].value === cname && item.node.selectedOptions[1].value === sname;
        });
        if (result) {
            return !result.node.availableForSale;
        }
        return false;
    };
    // 设置背景色图片
    var setColorBtnStyle = function(color) {
        var prefix = '/t/64/assets/';
        var colorText = color.toLocaleLowerCase().replace(/\s/g, '-');
        var colorArr = color.toLocaleLowerCase().split(' ');
        color = colorArr.length > 1 ? colorArr[1] : colorArr[0];
        color = color !== null && color !== void 0 ? color : 'white';
        return {
            backgroundImage: "url(".concat(constants/* SHOPIFY_CDN_PATH */.$o).concat(prefix).concat(colorText, "_50x.png)"),
            backgroundColor: color
        };
    };
    // 默认选中 或者sku级别的选中
    var getSelectByVariantid = function() {
        var options = get_default()(data, 'options');
        var selectItem = null;
        // sku级查找，图片index查找
        if (sku) {
            selectItem = variants.find(function(item) {
                return item.node.id === sku;
            });
        } else if (variantid) {
            selectItem = variants.find(function(item) {
                return item.node.image.id === variantid;
            });
        } else {
            selectItem = variants.find(function(item) {
                return item.node.availableForSale;
            });
        }
        var ref = _slicedToArray(selectItem ? selectItem.node.selectedOptions : variants === null || variants === void 0 ? void 0 : variants[0].node.selectedOptions, 2), citem = ref[0], sitem = ref[1];
        var result = handleClassifyAll(citem.value, sitem.value);
        setCurDataList(result);
        if (selectItem) {
            // const [citem, sitem] = selectItem.node.selectedOptions
            var curOpIndex = [
                result.color.indexOf(citem.value),
                result.size.indexOf(sitem.value), 
            ];
            setCurIndex(curOpIndex);
            return;
        }
        if (options && options.length) {
            // const result = handleClassifyAll()
            setCurIndex(Array(options.length).fill(0));
            return;
        }
        setCurIndex([
            0
        ]);
    };
    // 查找对应图片
    var handleSwiperIndex = function() {
        // setTimeout(() => {})
        var oVariant = get_default()(data, 'variants.edges', []) // 需要原始数据
        ;
        var images = get_default()(data, 'images.edges', []);
        var vindex = oVariant.findIndex(function(item) {
            return item.node.selectedOptions[0].value === curDataList.color[curIndex[0]];
        });
        var result = 0;
        if (vindex > -1) {
            result = images.findIndex(function(item) {
                return item.node.id === oVariant[vindex].node.image.id;
            });
        }
        return result;
    };
    /** 通过color size来查找 */ var getCurSelectPrice = function() {
        if (!data) {
            return;
        }
        var resultStr = "".concat(curDataList.color[curIndex[0]], " / ").concat(curDataList.size[curIndex[1]]);
        for(var i = 0; i < variants.length; i++){
            if (variants[i].node.title === resultStr) {
                setCurSelectInfo(variants[i].node);
                onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(ProductsSelect_objectSpread({
                }, variants[i].node, {
                    swiperIndex: handleSwiperIndex()
                }));
                break;
            }
        }
    };
    // 设置选中
    var handleSelectClick = function(name, index, param) {
        var type = param === void 0 ? 0 : param;
        if (type === 0) {
            var size = handleClassifySize(name) || [];
            var sindex = size[curIndex[1]] ? curIndex[1] : 0;
            setCurIndex([
                index,
                sindex
            ]);
            setCurDataList(ProductsSelect_objectSpread({
            }, curDataList, {
                size: size
            }));
        } else {
            var color = handleClassifyColor(name) || [];
            var cindex = color[curIndex[0]] ? curIndex[0] : 0;
            setCurIndex([
                cindex,
                index
            ]);
            setCurDataList(ProductsSelect_objectSpread({
            }, curDataList, {
                color: color
            }));
        }
    // getCurSelectPrice()
    };
    // 处理脏数据
    var handleDirtyDataOptions = function() {
        setCurIndex([
            0
        ]);
        setCurSelectInfo(variants[0].node);
        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(ProductsSelect_objectSpread({
        }, variants[0].node, {
            swiperIndex: 0
        }));
    };
    var getSizeGuideTable = function($, param) {
        var status = param === void 0 ? true : param;
        var filterData = [];
        var result = {
        };
        if (status) {
            var _loop = function(i) {
                if (i > 0) {
                    filterData[i - 1] = [];
                }
                tbody[i].children.forEach(function(ele) {
                    if (ele.name === 'td') {
                        if (i > 0) {
                            filterData[i - 1].push(ele.children[0].data);
                        } else {
                            result[ele.children[0].data.toUpperCase()] = [];
                        }
                    }
                });
            };
            var tbody = $('.sizeChart-drawer__content tbody').eq(0).find('tr');
            for(var i = 0; i < tbody.length; i += 1)_loop(i);
            Object.keys(result).forEach(function(item, idx) {
                filterData.forEach(function(item2) {
                    result[item].push(item2[idx]);
                });
            });
        }
        return result;
    };
    var getSizeGuideData = _asyncToGenerator(runtime_default().mark(function _callee() {
        var cheerio, $, status, body, sizeItemArr;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 311).then(__webpack_require__.t.bind(__webpack_require__, 62311, 23));
                case 2:
                    cheerio = _ctx.sent.default;
                    $ = cheerio.load(get_default()(data, 'descriptionHtml'));
                    status = !!$('.sizeChart-drawer__content').html();
                    setHasSizeGuide(status);
                    body = getSizeGuideTable($, status) || {
                    };
                    sizeItemArr = Array.from($('.sizeContainer')).map(function(item) {
                        var sizeItems = [];
                        item.children.forEach(function(item2) {
                            var titles = get_default()(item2, 'children[1].children[0].data', '');
                            var values = get_default()(item2, 'children[1].next.data');
                            if (titles && values) {
                                sizeItems.push({
                                    titles: item2.children[1].children[0].data.replace(':', ''),
                                    values: item2.children[1].next.data
                                });
                            }
                        });
                        return {
                            id: item.attribs.id,
                            data: sizeItems,
                            body: body
                        };
                    });
                    setSizeItem(sizeItemArr);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var sizeIndex = (0,react.useMemo)(function() {
        if (curIndex && curIndex.length > 1 && sizeItem) {
            var id = curDataList.size[curIndex[1]].replace('/', '-');
            return sizeItem.findIndex(function(item) {
                return item.id.indexOf(id) > -1;
            });
        }
        return 0;
    }, [
        curIndex,
        sizeItem
    ]);
    // 初始化数据
    var initialData = function() {
        if (!data) {
            return;
        }
        // 处理脏数据
        if (isNormalData) {
            handleClassify() // 处理分类是否为空的
            ;
            getSelectByVariantid();
        } else {
            handleDirtyDataOptions();
        }
        // getCurSelectPrice()
        getSizeGuideData();
    };
    (0,react.useEffect)(function() {
        if (data) {
            initialData();
        }
    }, []);
    (0,react.useEffect)(function() {
        getCurSelectPrice();
    }, [
        curDataList,
        curIndex
    ]);
    return data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isNormalData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    curDataList.color.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "variant-wrapper mt-3.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-xs min-w-full mb-2 md:text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold",
                                        children: "Color: "
                                    }),
                                    curDataList.color[curIndex[0]]
                                ]
                            }),
                            curDataList.color.map(function(i, idx) {
                                var ref;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-empty": handleBtnDisabled(idx, curIndex[1]),
                                    className: "colorbtn ".concat(idx === curIndex[0] ? 'ischecked' : '', " ").concat(((ref = classifyList[i]) === null || ref === void 0 ? void 0 : ref.isempty) || handleBtnDisabled(idx, curIndex[1]) ? 'isdisabled' : ''),
                                    style: setColorBtnStyle(i),
                                    onClick: function() {
                                        handleSelectClick(i, idx, 0);
                                    }
                                }, i));
                            })
                        ]
                    }),
                    curDataList.size.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "variant-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-xs min-w-full mb-2 mt-0.5 flex justify-between items-center md:text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold",
                                            children: "Size(US) "
                                        })
                                    }),
                                    showSizeGuide && hasSizeGuide && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-black text-xs underline inline-flex items-center cursor-pointer md:text-xs",
                                        onClick: onOpenSizeGuide,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiRuler */.TOP, {
                                                size: 18,
                                                color: "#000",
                                                className: "mr-1"
                                            }),
                                            "Size Guide"
                                        ]
                                    })
                                ]
                            }),
                            (ref9 = curDataList.size) === null || ref9 === void 0 ? void 0 : ref9.map(function(i, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "sizebtn ".concat(idx === curIndex[1] ? 'ischecked font-semibold' : "".concat(handleBtnDisabled(curIndex[0], idx) ? ' isdisabled' : '')),
                                    onClick: function() {
                                        return handleSelectClick(i, idx, 1);
                                    },
                                    children: i
                                }, i);
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            }),
            (sizeItem === null || sizeItem === void 0 ? void 0 : (ref1 = sizeItem[sizeIndex]) === null || ref1 === void 0 ? void 0 : ref1.data) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sizeallform flex flex-wrap items-center text-xs p-3 pb-1.5 bg-tag-grayf5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex pb-1.5",
                        children: [
                            'US',
                            'UK',
                            'EU'
                        ].map(function(item) {
                            return sizeItem[sizeIndex].body[item] && sizeItem[sizeIndex].body[item].length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-flex mr-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            item,
                                            " Size:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-black text-opacity-40 ml-2",
                                        children: sizeItem[sizeIndex].body[item][sizeIndex]
                                    })
                                ]
                            }, item);
                        })
                    }),
                    (ref2 = sizeItem[sizeIndex]) === null || ref2 === void 0 ? void 0 : ref2.data.map(function(i, idx) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center w-2/4 pb-1.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        i.titles,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-black text-opacity-40 ml-2",
                                    children: i.values
                                })
                            ]
                        }, i.values + idx);
                    })
                ]
            }) : null,
            errorMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-tag-grayf6 text-tag-error mt-2.5 text-center px-3 py-1.5 text-xs border-1 border-tag-error block md:hidden",
                children: errorMsg
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    });
};
/* harmony default export */ var ProductsSelect = (ProductSelect);

// EXTERNAL MODULE: ../../node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(34543);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
;// CONCATENATED MODULE: ./src/components/products/ProductsModel.tsx



// import cheerio from 'cheerio'



function ProductsModel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductsModel_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsModel_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsModel_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsModel_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsModel_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductsModel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function ProductsModel_slicedToArray(arr, i) {
    return ProductsModel_arrayWithHoles(arr) || ProductsModel_iterableToArrayLimit(arr, i) || ProductsModel_nonIterableRest();
}
// tie-dye-long-casual-sweatshirt
var ProductsModel_ProductSelect = function(param) {
    var data = param.data;
    var ref6;
    var ref1 = (0,react.useState)(false), openStatus = ref1[0], setOpenStatus = ref1[1];
    var ref2 = (0,react.useState)({
    }), modelData = ref2[0], setModelData = ref2[1];
    var ref3 = (0,react.useState)([]), collapsible = ref3[0], setCollapsible = ref3[1];
    var ref4 = (0,react.useState)(0), sizeGuideIndex = ref4[0], setSizeGuideIndex = ref4[1];
    var ref5 = (0,react.useState)([]), tabData = ref5[0], setTabData = ref5[1];
    function initialData() {
        return _initialData.apply(this, arguments);
    }
    function _initialData() {
        _initialData = // const tableData: any[] = [] //
        ProductsModel_asyncToGenerator(runtime_default().mark(function _callee() {
            var cheerio, $, MODEL_DOM, MODEL_WEARS, INNER, ref7, HEIGHT, BUST, WAIST, HIPS, collapsibles, SIMPLE_SIZEGUIDE_DOM, TAB_DATA_ITEM, TAB_DATA_ITILE, result, i;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return __webpack_require__.e(/* import() */ 311).then(__webpack_require__.t.bind(__webpack_require__, 62311, 23));
                    case 4:
                        cheerio = _ctx.sent.default;
                        $ = cheerio.load(get_default()(data, 'descriptionHtml'));
                        MODEL_DOM = $('.product-intro__sizeguide-summary-list');
                        if (MODEL_DOM && (MODEL_DOM === null || MODEL_DOM === void 0 ? void 0 : MODEL_DOM.length) > 0) {
                            MODEL_WEARS = $('.product-intro__sizeguide-summary-list').find('div > span')[0].children[0].data;
                            INNER = $('.inner img')[0].attribs.src || '';
                            ref7 = ProductsModel_slicedToArray(Array.from($('.model-item > div > span')).map(function(item) {
                                return item.children[0].data;
                            }), 4), HEIGHT = ref7[0], BUST = ref7[1], WAIST = ref7[2], HIPS = ref7[3];
                            /** 设置模特数据 */ setModelData({
                                INNER: INNER,
                                MODEL_WEARS: MODEL_WEARS,
                                HEIGHT: HEIGHT,
                                BUST: BUST,
                                WAIST: WAIST,
                                HIPS: HIPS
                            });
                        } else {
                            setModelData(null);
                        }
                        collapsibles = Array.from($('.collapsible-content__inner > p')).map(function(item) {
                            var ref;
                            return (ref = item.children[0]) === null || ref === void 0 ? void 0 : ref.data.split(':');
                        });
                        SIMPLE_SIZEGUIDE_DOM = $('.tableList');
                        if (SIMPLE_SIZEGUIDE_DOM && SIMPLE_SIZEGUIDE_DOM.length > 0) {
                            TAB_DATA_ITEM = SIMPLE_SIZEGUIDE_DOM.find('.table');
                            TAB_DATA_ITILE = $('.tab .tabSpan');
                            result = [];
                            for(i = 0; i < TAB_DATA_ITEM.length; i += 1){
                                // console.log('index', TAB_DATA_ITEM.eq(i).html())
                                result.push({
                                    name: TAB_DATA_ITILE.eq(i).text(),
                                    data: TAB_DATA_ITEM.eq(i).find('>div').html()
                                });
                            }
                            // console.log('item....', result)
                            setTabData(result);
                        }
                        // console.log('折叠数据', collapsibles)
                        setCollapsible(collapsibles);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _initialData.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            modelData && modelData.INNER ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "model-wrapper pt-4 mx-3 border-b md:border-none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-black text-sm font-semibold md:text-15",
                        children: "Model's Measurements"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full my-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-16 h-16 overflow-hidden relative bg-cover rounded-full",
                                style: {
                                    backgroundImage: "url(".concat(modelData === null || modelData === void 0 ? void 0 : modelData.INNER, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-4 flex flex-1 flex-col text-xs md:text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-1 items-center whitespace-nowrap",
                                                children: [
                                                    "Model Wears:",
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400 ml-1",
                                                        children: modelData.MODEL_WEARS
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-1 items-center ml-1"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-xs flex flex-1 items-center whitespace-nowrap",
                                                children: [
                                                    "Height:",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400 ml-1",
                                                        children: modelData.HEIGHT
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-1 items-center whitespace-nowrap",
                                                children: [
                                                    "Bust:",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: " text-gray-400 ml-1",
                                                        children: modelData.BUST
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-1 items-center whitespace-nowrap",
                                                children: [
                                                    "Waist:",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400 ml-1",
                                                        children: modelData.WAIST
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-1 items-center whitespace-nowrap",
                                                children: [
                                                    "Hips:",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400 ml-1",
                                                        children: modelData.HIPS
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:mt-3"
            }),
            tabData && tabData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tab-wrapper mt-3 ml-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-item",
                        children: tabData.map(function(i, idx) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cursor-pointer inline-flex h-7 px-4 items-center justify-center text-xs font-semibold border-2 border-black mr-3 ".concat(sizeGuideIndex === idx ? 'bg-black text-white h-8' : ''),
                                onClick: function() {
                                    return setSizeGuideIndex(idx);
                                },
                                children: i === null || i === void 0 ? void 0 : i.name
                            }, i === null || i === void 0 ? void 0 : i.name));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "table-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overflow-x-auto nobar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs md:text-sm mt-1.5 md:mb-2.5 leading-normal",
                                dangerouslySetInnerHTML: {
                                    __html: (ref6 = tabData[sizeGuideIndex]) === null || ref6 === void 0 ? void 0 : ref6.data
                                }
                            })
                        })
                    })
                ]
            }),
            collapsible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "details-wrapper md:border-1 md:border-black md:mb-3.5 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between mx-2.5 h-11 sm:border-t items-center md:justify-center relative cursor-pointer border-tag-graye9",
                        onClick: function() {
                            setOpenStatus(!openStatus);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-black text-sm font-medium md:font-montserrat md:font-normal",
                                children: "Details"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "transform md:color-black absolute right-0 md:text-lg ".concat(openStatus ? 'rotate-90' : 'rotate-225'),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
                                    size: 16,
                                    color: "#999999"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: openStatus,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-2.5",
                            children: collapsible.map(function(i, idx) {
                                return i && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xs leading-1 pb-4 z-10 text-gray-500",
                                    children: i.join(': ')
                                }, idx);
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ProductsModel = (ProductsModel_ProductSelect);

;// CONCATENATED MODULE: ./src/components/products/ProductsSizeGuide.tsx


/* eslint-disable no-plusplus */ 
function ProductsSizeGuide_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsSizeGuide_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsSizeGuide_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsSizeGuide_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ProductSizeGuide = function(param) {
    var data = param.data, open = param.open, onBack = param.onBack;
    var initDomEvent = // 初始化dom事件，用最蠢的方法了
    function initDomEvent() {
        setTimeout(function() {
            // IN / CM change
            var tabDom = document.querySelectorAll('.sg-title-ctn li');
            var tableDom = document.querySelectorAll('.sizeBox');
            tabDom.forEach(function(item, index) {
                item === null || item === void 0 ? void 0 : item.addEventListener('click', function(e) {
                    e.stopPropagation();
                    tabDom.forEach(function(item2) {
                        item2.classList.remove('title-active');
                    });
                    item.classList.add('title-active');
                    setTabIndex(index);
                    tableDom.forEach(function(item2) {
                        // eslint-disable-next-line no-param-reassign
                        item2.style.display = 'none';
                    });
                    var dom = tableDom[index];
                    if (dom) dom.style.display = 'block';
                });
            });
            // 折叠
            var measureArr = document.querySelectorAll('.measure-guide__header');
            measureArr.forEach(function(item) {
                item === null || item === void 0 ? void 0 : item.addEventListener('click', function(e) {
                    var ref;
                    e.stopPropagation();
                    var measure = (ref = item.parentNode) === null || ref === void 0 ? void 0 : ref.children[1];
                    var icon = item.children[1];
                    var isDisplay = measure === null || measure === void 0 ? void 0 : measure.classList.contains('displayNone');
                    if (isDisplay) {
                        measure === null || measure === void 0 ? void 0 : measure.classList.remove('displayNone');
                        icon === null || icon === void 0 ? void 0 : icon.classList.add('iconfont-active');
                    } else {
                        measure === null || measure === void 0 ? void 0 : measure.classList.add('displayNone');
                        icon === null || icon === void 0 ? void 0 : icon.classList.remove('iconfont-active');
                    }
                }, false);
            });
            // 尺寸切换
            var sizeBtn = document.querySelectorAll('.common-sizemeasure__sizeChart-size span');
            sizeBtn.forEach(function(item, index) {
                item === null || item === void 0 ? void 0 : item.addEventListener('click', function(e) {
                    var ref;
                    e.stopPropagation();
                    var nextParent = (ref = item.parentNode) === null || ref === void 0 ? void 0 : ref.parentNode.children[2];
                    var curParent = item.parentNode;
                    var curIndex = index % (sizeBtn.length / 2);
                    for(var i = 0; i < curParent.children.length; i++){
                        curParent.children[i].classList.remove('common-sizemeasure__sizeChart-sizeSelect');
                        nextParent.children[i].style.display = 'none';
                    }
                    curParent.children[curIndex].classList.add('common-sizemeasure__sizeChart-sizeSelect');
                    nextParent.children[curIndex].style.display = 'block';
                });
            });
            // 返回
            var closeBtn = document.querySelectorAll('.closeSize');
            closeBtn.forEach(function(item) {
                item.addEventListener('click', function() {
                    onBack === null || onBack === void 0 ? void 0 : onBack(false);
                });
            });
        }, 0);
    };
    var ref2 = (0,react.useState)(), tableData = ref2[0], setTableData = ref2[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref1 = (0,react.useState)(0), tabIndex = ref1[0], setTabIndex = ref1[1];
    (0,react.useEffect)(function() {
        function initSizeGuideData() {
            return _initSizeGuideData.apply(this, arguments);
        }
        function _initSizeGuideData() {
            _initSizeGuideData = ProductsSizeGuide_asyncToGenerator(runtime_default().mark(function _callee() {
                var cheerio, $;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (data) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.next = 4;
                            return __webpack_require__.e(/* import() */ 311).then(__webpack_require__.t.bind(__webpack_require__, 62311, 23));
                        case 4:
                            cheerio = _ctx.sent.default;
                            $ = cheerio.load(data === null || data === void 0 ? void 0 : data.descriptionHtml);
                            setTableData($('.sizeChart-drawer__content').html());
                            initDomEvent();
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _initSizeGuideData.apply(this, arguments);
        }
        initSizeGuideData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        open
    ]);
    return tableData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sizeguide-wrapper text-xs md:text-sm fixed w-full h-full overflow-x-auto top-0 bg-gray-100 transition-all ease-in-out duration-300 ".concat(open ? 'right-0' : '-right-full'),
        style: {
            zIndex: 1800
        },
        children: open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "table-wrapper w-fullbg-black",
            dangerouslySetInnerHTML: {
                __html: tableData || ''
            }
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    });
};
/* harmony default export */ var ProductsSizeGuide = (ProductSizeGuide);

// EXTERNAL MODULE: ./src/components/products/reviews/Rating.tsx + 1 modules
var Rating = __webpack_require__(23035);
// EXTERNAL MODULE: ./src/components/Icon.tsx
var Icon = __webpack_require__(71561);
;// CONCATENATED MODULE: ./src/components/products/ProductsMeta.tsx





var ProductsMeta = function(param) {
    var data = param.data, selectInfo = param.selectInfo, className = param.className, children = param.children, _openShare = param.openShare, openShare = _openShare === void 0 ? true : _openShare, reviews = param.reviews, onShare = param.onShare;
    var goReviewsSection = // const [showDiscount, setShowDiscount] = useState<boolean>(false)
    function goReviewsSection() {
        var ref;
        var location = (ref = document.querySelector) === null || ref === void 0 ? void 0 : ref.call(document, '.reviews-wrapper');
        if (location) {
            // console.log(location?.offsetTop)
            window === null || window === void 0 ? void 0 : window.scrollTo(0, (location === null || location === void 0 ? void 0 : location.offsetTop) - 100);
        }
    };
    var handelPercent = function handelPercent() {
        var price = selectInfo.price, compareAtPrice = selectInfo.compareAtPrice;
        return "".concat(Math.round((1 - price / compareAtPrice) * 100), "%");
    };
    var showDiscount = (0,react.useMemo)(function() {
        var price = selectInfo.price, compareAtPrice = selectInfo.compareAtPrice;
        if (selectInfo && compareAtPrice && Number(compareAtPrice) > Number(price)) {
            return true;
        }
        return false;
    }, [
        selectInfo,
        data
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-meta px-3 md:px-0 pb-4 ".concat(className || ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-black flex justify-between items-center text-sm md:text-xl md:font-bold leading-tight",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: " text-gray-500 font-medium md:text-gray-900 mt-3 mb-2.5",
                        children: data === null || data === void 0 ? void 0 : data.title
                    }),
                    openShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "openShare cursor-pointer block md:hidden",
                        onClick: onShare,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "share"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-semibold md:font-bold text-22 md:text-2xl ".concat(showDiscount ? 'text-tag-red' : ''),
                                children: [
                                    "$",
                                    selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.price
                                ]
                            }),
                            showDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-sm line-through mx-1.5 text-gray-600",
                                children: [
                                    "$",
                                    selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.compareAtPrice
                                ]
                            }),
                            showDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "bg-tag-red text-xss text-white h-3.5 px-1 inline-flex justify-center items-center font-semibold",
                                children: [
                                    "-",
                                    handelPercent()
                                ]
                            })
                        ]
                    }),
                    (reviews === null || reviews === void 0 ? void 0 : reviews.rating) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-xs text-gray-500 md:hidden flex items-center whitespace-nowrap cursor-pointer",
                        onClick: function() {
                            goReviewsSection();
                            window.localStorage.setItem('review_from', '2');
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                type: "outline",
                                value: reviews === null || reviews === void 0 ? void 0 : reviews.rating,
                                length: 5,
                                openHalf: true,
                                func: function(v) {
                                    return Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2;
                                },
                                className: "star-xs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pl-1",
                                children: [
                                    "(",
                                    reviews === null || reviews === void 0 ? void 0 : reviews.total,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
                                size: 15,
                                color: "#999999"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    }, data === null || data === void 0 ? void 0 : data.handle));
};
/* harmony default export */ var products_ProductsMeta = (ProductsMeta);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(52742);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(63072);
// EXTERNAL MODULE: ./src/components/SocialList.tsx
var SocialList = __webpack_require__(25729);
// EXTERNAL MODULE: ./src/components/lottery/LotteryReport.tsx
var LotteryReport = __webpack_require__(55289);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(67338);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
;// CONCATENATED MODULE: ./src/utils/deliveryData.ts


dayjs_min_default().extend((timezone_default()));
var deliveryData_config = {
    CAN: {
        country: 'Canada',
        standard: [
            16,
            22
        ],
        express: [
            6,
            12
        ],
        reg: 'Canada|Halifax|Winnipeg|Toronto|Edmonton|St_Johns|Vancouver|Regina|Whitehorse',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '12.99',
            express: '16.90'
        }
    },
    US: {
        country: 'United States',
        standard: [
            11,
            19
        ],
        express: [
            6,
            12
        ],
        reg: 'America',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    UK: {
        country: 'United Kingdom',
        standard: [
            9,
            15
        ],
        express: [
            9,
            13
        ],
        reg: 'London',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    AUS: {
        country: 'Australia',
        standard: [
            15,
            23
        ],
        express: [
            9,
            13
        ],
        reg: 'Australia',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    GER: {
        country: 'Germany',
        standard: [
            11,
            17
        ],
        express: [
            9,
            13
        ],
        reg: 'Berlin',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    ITA: {
        country: 'Italy',
        standard: [
            10,
            14
        ],
        express: [
            8,
            10
        ],
        reg: 'Rome',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    ES: {
        country: 'Spain',
        standard: [
            8,
            12
        ],
        express: [
            8,
            10
        ],
        reg: 'Madrid|Canary',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    FR: {
        country: 'Franch',
        standard: [
            7,
            11
        ],
        express: [
            8,
            10
        ],
        reg: 'Paris',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    NL: {
        country: 'Netherlands',
        standard: [
            8,
            12
        ],
        express: [
            8,
            10
        ],
        reg: 'Amsterdam',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    },
    IL: {
        country: 'Ireland',
        standard: [
            11,
            16
        ],
        express: [
            8,
            10
        ],
        reg: 'Dublin',
        standardDays: [],
        exppressDays: [],
        shippingPrice: {
            standard: '6.99',
            express: '16.90'
        }
    }
};
function formatDays(param) {
    var days = param === void 0 ? 0 : param;
    return dayjs_min_default()().add(days, 'day').format('MM/DD/YYYY');
}
function getCountryTimeZone() {
    // console.log('dayjs.tz.guess()', dayjs.tz.guess())
    var timeZone = dayjs_min_default().tz.guess() || 'America/New_York';
    timeZone = timeZone.split('/');
    // console.log('tiemZone', timeZone)
    var configKey = Object.keys(deliveryData_config);
    var result = deliveryData_config.US;
    for(var i = 0; i < configKey.length; i += 1){
        var keys = deliveryData_config[configKey[i]] || '';
        if (keys.reg.includes(timeZone[0]) || keys.reg.includes(timeZone[1])) {
            result = keys;
            break;
        }
    }
    result.standardDays = [
        formatDays(result.standard[0]),
        formatDays(result.standard[1]), 
    ];
    result.exppressDays = [
        formatDays(result.express[0]),
        formatDays(result.express[1]), 
    ];
    return result;
}
/* harmony default export */ var deliveryData = (getCountryTimeZone);

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./src/components/icon/Support.tsx



var Support = function(prop) {
    var sx = prop.sx, className = prop.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: sx || {
        },
        className: className || '',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-full",
            width: "24px",
            height: "23px",
            viewBox: "0 0 24 23",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "currentColor",
                            d: "M12,0 C16.8503559,0 20.7952645,3.86470097 20.9346074,8.68082095 L20.9384164,8.94444444 L20.9384164,17.6333333 C20.9384164,20.2406093 18.8819998,22.3709071 16.2985833,22.4841538 L16.0821114,22.4888889 L12.1707296,22.4888889 L12.1707296,20.9555556 L16.0821114,20.9555556 C17.8441027,20.9555556 19.287347,19.5707742 19.384786,17.8220435 L19.3900293,17.6333333 L19.3900293,8.94444444 C19.3900293,4.84945184 16.0794074,1.53333333 12,1.53333333 C8.00218077,1.53333333 4.74270307,4.71813355 4.61392309,8.69969984 L4.60997067,8.94444444 L4.60997067,16.1 L3.06158358,16.1 L3.06158358,8.94444444 C3.06158358,4.00651314 7.0614558,0 12,0 Z",
                            fillRule: "nonzero"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M3.83577713,8.17777778 L0.774193548,8.17777778 C0.346618258,8.17777778 0,8.52102614 0,8.94444444 L0,15.5888889 C0,16.0123072 0.346618258,16.3555556 0.774193548,16.3555556 L3.83577713,16.3555556 C4.26335242,16.3555556 4.60997067,16.0123072 4.60997067,15.5888889 L4.60997067,8.94444444 C4.60997067,8.52102614 4.26335242,8.17777778 3.83577713,8.17777778 Z M3.06119648,9.7105303 L3.06119648,14.8221758 L1.54775367,14.8221758 L1.54775367,9.7105303 L3.06119648,9.7105303 Z",
                            fillRule: "nonzero"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M23.2258065,8.68888889 L20.1642229,8.68888889 C19.7366476,8.68888889 19.3900293,9.03213725 19.3900293,9.45555556 L19.3900293,16.1 C19.3900293,16.5234183 19.7366476,16.8666667 20.1642229,16.8666667 L23.2258065,16.8666667 C23.6533817,16.8666667 24,16.5234183 24,16.1 L24,9.45555556 C24,9.03213725 23.6533817,8.68888889 23.2258065,8.68888889 Z M22.4512258,10.221897 L22.4512258,15.3325318 L20.937783,15.3325318 L20.937783,10.221897 L22.4512258,10.221897 Z",
                            fillRule: "nonzero",
                            transform: "translate(21.695015, 12.777778) scale(-1, 1) translate(-21.695015, -12.777778) "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "9.95894428",
                            y: "20.4444444",
                            width: "3.57184751",
                            height: "2.55555556"
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var icon_Support = (Support);

;// CONCATENATED MODULE: ./src/components/products/ProductsSection.tsx






// import { AiOutlineSafety } from 'react-icons/ai'







function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
// import { useMemo } from 'hoist-non-react-statics/node_modules/@types/react'
// import { PropsWithChildren } from 'react-transition-group/node_modules/@types/react'
var COUPONS_LIST = [
    {
        KEY: 5,
        TEXT: '$5 OFF $39'
    },
    {
        KEY: 10,
        TEXT: '$10 OFF $69'
    },
    {
        KEY: 15,
        TEXT: '$15 OFF $99'
    },
    {
        KEY: 20,
        TEXT: '$20 OFF $129'
    },
    {
        KEY: 25,
        TEXT: '$25 OFF $159'
    }, 
];
var CouponsList = function() {
    var handleCouponDialog = function handleCouponDialog(idx) {
        setIndex(idx);
        setOpen(true);
    };
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(0), index = ref1[0], setIndex = ref1[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: open,
                maxWidth: "xl",
                onClose: function() {
                    return setOpen(false);
                },
                transitionDuration: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center items-center h-70 px-5 py-10 overflow-hidden mt-3.5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "coupon--item h-20 text-2xl font-semibold w-64 mr-0",
                            children: COUPONS_LIST[index].TEXT
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-black text-15 font-bold mt-9 mb-3",
                            children: [
                                "Coupon code: LOVE",
                                COUPONS_LIST[index].KEY
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-black text-opacity-70 text-sm mb-8",
                            children: "Apply a coupon code at checkout."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex w-full justify-center items-center h-11 bg-black text-white cursor-pointer",
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: "OK"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "coupon-wrapper pl-3 pt-4 pb-4 md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "coupon-tit text-black text-sm font-semibold mb-2",
                        children: "Coupons"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "coupon-list h-7 flex flex-nowrap overflow-y-hidden overscroll-x-auto nobar",
                        children: COUPONS_LIST.map(function(i, idx) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "coupon--item h-7 text-xs mr-2 font-semibold",
                                onClick: function() {
                                    return handleCouponDialog(idx);
                                },
                                children: i.TEXT
                            }, i.KEY);
                        })
                    })
                ]
            })
        ]
    }));
};
// 切割条
var SplitBar = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "splitbar md:hidden"
    });
};
// 运费说明
var DeliveryInfo = function() {
    var ref = (0,react.useState)(''), result = ref[0], setResult = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if ( true && !router.isFallback) {
            setResult(deliveryData());
        }
    }, [
        router.isFallback
    ]);
    return result && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "delivery-wrapper pt-4 px-3 pr-0 md:px-0 md:mb-3.5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "coupon-tit text-black text-sm leading-1.6 font-semibold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "md:hidden",
                    children: "Shipping & Returns"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "delivery--item pb-2.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/pages/shipping-1",
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center pt-3 pb-1.5 mr-3 md:pointer-events-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-12 inline-flex items-center md:pointer-events-none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: "logistics",
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "ml-2",
                                            children: [
                                                "Delivery to ",
                                                result.country
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-1 justify-end items-center md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "leading-1.2 text-10 text-gray-400",
                                            children: "More"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
                                            size: 16,
                                            color: "#999999"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-nowrap overflow-y-hidden overscroll-x-auto md:overflow-hidden nobar",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:w-1/2 inline-flex flex-col bg-tag-grayf5 flex-shrink-0 text-xs box-border leading-normal mr-2 text-gray-400 py-2.5 pl-3 pr-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-1.5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Standard shipping:\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-xs text-black",
                                                        children: [
                                                            "$",
                                                            result.shippingPrice.standard
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Free for orders over\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-xs text-tag-greens",
                                                        children: "$59"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "break-all",
                                        children: [
                                            "Estimated delivery on ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: result.standardDays[0]
                                            }),
                                            "\xa0-\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: result.standardDays[1]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:w-1/2 inline-flex flex-col bg-tag-grayf5 flex-shrink-0 text-xs box-border leading-normal mr-2 text-gray-400 py-2.5 pl-3 pr-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-1.5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                "Express shipping:\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-xs text-black",
                                                    children: [
                                                        "$",
                                                        result.shippingPrice.express
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "break-all",
                                        children: [
                                            "Estimated delivery on ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: result.exppressDays[0]
                                            }),
                                            "\xa0-\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: result.exppressDays[1]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-10 text-gray-400 flex mt-2.5 mr-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "delivery_tips",
                                className: "mr-0.5",
                                width: 14,
                                height: 14
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " inline-flex flex-1",
                                children: "Delivery times will be slightly longer than normal due to global supply chain disruptions throughout the New Year‘s Day."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "delivery--item py-3 md:hidden mr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/pages/return-policy",
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-12 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "freereturn_icon",
                                        width: 20,
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Free Returns"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "leading-1.2 text-10 text-gray-400",
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
                                        size: 16,
                                        color: "#999999"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var ProductFooter = function(props) {
    var canBuy = props.canBuy, onAddClick = props.onAddClick, forBtn = props.forBtn, loading = props.loading, errorMsg = props.errorMsg;
    var handleAddClick = function() {
        if (!canBuy) return;
        (0,LotteryReport/* default */.Z)('lottery_add_to_cart');
        onAddClick === null || onAddClick === void 0 ? void 0 : onAddClick();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "buy-wrapper",
        children: forBtn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    loading: loading,
                    disabled: !canBuy,
                    className: "button--primary text-sm hidden py-3 md:block w-full",
                    onClick: handleAddClick,
                    children: canBuy ? 'Add To Cart' : 'Sold Out'
                }),
                errorMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:block text-sm text-center px-3 py-1.5 border-1 border-tag-error text-tag-error",
                    children: errorMsg
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed bottom-0 w-full h-14 flex items-center bg-white z-20 cursor-pointer md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-20 leading-1 items-center h-14 justify-center",
                        onClick: function() {
                            // @ts-ignore
                            ud('showPanel');
                            // @ts-ignore
                            $BasePageSensor.ChatClick();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Support, {
                                className: "w-4.5 h-7 pt-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs",
                                children: "Support"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        loading: loading,
                        onClick: handleAddClick,
                        disabled: !canBuy,
                        className: "button--primary h-14 font-semibold w-full tracking-normal",
                        children: canBuy ? 'Add To Cart' : 'Sold Out'
                    })
                ]
            })
        })
    }));
};
var iconsList = [
    {
        title: 'Share',
        iconName: 'facebook',
        domain: 'https://www.facebook.com/sharer.php',
        link: 'u=url'
    },
    {
        title: 'Tweet',
        iconName: 'tweet',
        domain: 'https://twitter.com/share',
        link: 'text=title&url=url'
    },
    {
        title: 'Pin it',
        iconName: 'pinterest',
        domain: 'https://pinterest.com/pin/create/button',
        link: 'url=url&media=image&description=title'
    }, 
];
var ProductShare = function(props) {
    var open = props.open, data = props.data, onOpenChange = props.onOpenChange;
    var ref3 = (0,react.useState)(_toConsumableArray(iconsList)), shareData = ref3[0], setShareData = ref3[1];
    (0,react.useEffect)(function() {
        var ref, ref2;
        if (!data) {
            return;
        }
        var title = data === null || data === void 0 // https://service-hh4bv970-1253813979.gz.apigw.tencentcs.com // encodeURIComponent(window.location.href)
         ? void 0 : data.title;
        var imgurl = (data === null || data === void 0 ? void 0 : (ref = data.images) === null || ref === void 0 ? void 0 : (ref2 = ref.edges) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? data.images.edges[0].node.src : '';
        var link = window.location.href;
        shareData[0].link = "".concat(shareData[0].domain, "?u=").concat(link);
        shareData[1].link = "".concat(shareData[1].domain, "?text=").concat(title, "&url=").concat(link);
        shareData[2].link = "".concat(shareData[2].domain, "?url=").concat(link, "&media=").concat(imgurl, "&description=").concat(title);
        setShareData(_toConsumableArray(shareData));
    }, [
        data.images
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed top-0 left-0 w-full h-full md:z-0 ".concat(open ? 'block z-50' : 'hidden', " md:hidden bg-black bg-opacity-50"),
                onClick: function() {
                    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "share-wrapper md:flex ".concat(open ? 'sm:flex z-50' : 'hidden', " flex felx-full items-center justify-center text-sm p-4 md:p-10 fixed bottom-0 left-0 right-0 w-full bg-white sm:h-15 md:relative"),
                children: shareData.map(function(i, idx) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "inline-flex justify-center mx-5",
                        target: "_blank",
                        href: i.link,
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-5 h-5 text-sm inline-block mr-2",
                                children: SocialList/* icons */.c[i === null || i === void 0 ? void 0 : i.iconName]
                            }),
                            i.title
                        ]
                    }, idx));
                })
            })
        ]
    }));
};
var BackToCollection = function() {
    var router = (0,next_router.useRouter)();
    var collectionTitle = router.query.collectionTitle;
    if (collectionTitle) {
        collectionTitle = collectionTitle.split('-').map(function(i) {
            return i[0].toUpperCase() + i.slice(1);
        }).join(' ');
    }
    return collectionTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "justify-center w-full hidden md:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " bg-black text-white inline-flex items-center h-12 px-5 mt-10 cursor-pointer mb-5",
            onClick: function() {
                router.back();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineArrowNarrowLeft */.XJf, {
                    size: 20,
                    className: "mr-2"
                }),
                "Back to ",
                collectionTitle
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    });
};

// EXTERNAL MODULE: ./src/hooks/useCart.tsx
var useCart = __webpack_require__(37762);
// EXTERNAL MODULE: ./src/components/skeleton.tsx
var skeleton = __webpack_require__(89096);
// EXTERNAL MODULE: ./src/utils/product.ts
var product = __webpack_require__(95249);
;// CONCATENATED MODULE: ./src/pages/products/[name].tsx


/* eslint-disable react/prop-types */ 










// import ProductsRecommend from '../../components/products/ProductsRecommend'
// import ProductsReviews from '../../components/products/ProductsReviews'




function _name_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _name_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _name_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _name_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _name_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _name_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _name_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductsRecommend = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 474).then(__webpack_require__.bind(__webpack_require__, 18474));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18474)
            ];
        },
        modules: [
            "products/[name].tsx -> " + "../../components/products/ProductsRecommend"
        ]
    }
});
// const ProductsReviews = dynamic(
//   () => import('../../components/products/ProductsReviews')
// )
var ProductsReviewsNew = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(424), __webpack_require__.e(285), __webpack_require__.e(546), __webpack_require__.e(388), __webpack_require__.e(60), __webpack_require__.e(258)]).then(__webpack_require__.bind(__webpack_require__, 35060));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35060)
            ];
        },
        modules: [
            "products/[name].tsx -> " + "../../components/products/ProductsReviewsNew"
        ]
    }
});
var _name_productPageSensorMod = function() {
    return __webpack_require__.e(/* import() */ 506).then(__webpack_require__.bind(__webpack_require__, 12506));
};
var _name_productPageSensor;
// ProductsPage Entry
var ProductsPage = function(props) {
    var ref13, ref1, ref2;
    // const { seo, images } = props.product
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useCart/* default */.ZP)(), addLines = ref3.addLines, show = ref3.show, loading = ref3.loading;
    // const { name } = router.query
    // const [productInfo, setProductInfo] = useState<any>(null)
    var ref4 = (0,react.useState)({
    }), moreProductInfo = ref4[0], setMoreProductInfo = ref4[1];
    var ref5 = (0,react.useState)({
    }), selectInfo = ref5[0], setSelectInfo = ref5[1];
    var ref6 = (0,react.useState)(0), swiperIndex = ref6[0], setSwiperIndex = ref6[1];
    var ref7 = (0,react.useState)(true), canBuy = ref7[0], setCanBuy = ref7[1];
    var ref8 = (0,react.useState)(false), openSizeGuide = ref8[0], setOpenSizeGuide = ref8[1];
    var ref9 = (0,react.useState)(false), openShare = ref9[0], setOpenShare = ref9[1];
    var ref10 = (0,react.useState)({
        rating: -1,
        total: -1
    }), reviews = ref10[0], setReviews = ref10[1];
    var ref11 = (0,react.useState)(false), showLimitTips = ref11[0], setShowLimitTips = ref11[1];
    // const { query } = useGetProductByHandler(name as string)
    // const info = get(query, 'data.product') as ProductByHandleQuery['product']
    var productInfo = (0,react.useMemo)(function() {
        return get_default()(props, 'product');
    }, [
        props
    ]);
    var seo = (0,react.useMemo)(function() {
        return get_default()(props, 'product.seo');
    }, [
        props
    ]);
    var fbImage = (0,react.useMemo)(function() {
        return get_default()(props, 'product.images.edges[0].node.originalSrc', '');
    }, [
        props
    ]);
    // const pageLoading = useMemo(() => !router.isFallback, [router.isFallback])
    var handleAdd = _name_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, back;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return addLines([
                        selectInfo
                    ], true);
                case 3:
                    back = _ctx.sent;
                    _name_productPageSensor === null || _name_productPageSensor === void 0 ? void 0 : _name_productPageSensor.AddToCartClick(productInfo === null || productInfo === void 0 ? void 0 : productInfo.title, selectInfo);
                    window === null || window === void 0 ? void 0 : (ref = window.allPixels) === null || ref === void 0 ? void 0 : ref.addToCart(productInfo, selectInfo);
                    if (back) {
                        show();
                    } else {
                        setShowLimitTips(true);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    /** 初始化选中sku信息 */ var onSelectChange = function(e) {
        setSelectInfo(e);
        setSwiperIndex(e === null || e === void 0 ? void 0 : e.swiperIndex);
        setCanBuy(e && (e === null || e === void 0 ? void 0 : e.availableForSale));
    };
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if ( true && productInfo) {
            setMoreProductInfo({
                available: (0,product/* getProductIsAvailable */.pk)(productInfo),
                spu: (0,product/* getProductSPU */.Mx)(productInfo)
            });
            if (true) {
                window === null || window === void 0 ? void 0 : window.allPixels.viewProduct(productInfo);
            }
        }
    }, [
        productInfo
    ]);
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if ( true && productInfo && reviews.total !== -1) {
            _name_productPageSensorMod().then(function(mod) {
                if (window.scrollLock) return;
                _name_productPageSensor = new mod.ProductPageSensor();
                _name_productPageSensor === null || _name_productPageSensor === void 0 ? void 0 : _name_productPageSensor.ProductPageShow(productInfo, reviews);
                window.productReportData = {
                    productInfo: productInfo,
                    reviews: reviews
                };
            });
        }
    }, [
        productInfo,
        reviews.total
    ]);
    var Seo = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: seo === null || seo === void 0 ? void 0 : seo.title
                }),
                (seo === null || seo === void 0 ? void 0 : seo.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: seo === null || seo === void 0 ? void 0 : seo.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:site_name",
                    content: "BloomChic"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:title",
                    content: (seo === null || seo === void 0 ? void 0 : seo.title) || 'BloomChic'
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:type",
                    content: "product"
                }),
                (seo === null || seo === void 0 ? void 0 : seo.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:description",
                    content: seo === null || seo === void 0 ? void 0 : seo.description
                }),
                fbImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: fbImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:secure_url",
                            content: fbImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:width",
                            content: "750"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:height",
                            content: "1000"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:site",
                    content: "@"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                (seo === null || seo === void 0 ? void 0 : seo.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:title",
                    content: seo === null || seo === void 0 ? void 0 : seo.title
                }),
                (seo === null || seo === void 0 ? void 0 : seo.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:description",
                    content: seo === null || seo === void 0 ? void 0 : seo.description
                })
            ]
        }));
    };
    var errorMsg = (0,react.useMemo)(function() {
        // console.log('showlimitTips', showLimitTips, selectInfo, productInfo)
        if (showLimitTips && selectInfo && productInfo) {
            return " All ".concat(selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.quantityAvailable, " ").concat(productInfo.title, " -\n        ").concat(selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.title, " are in you cart");
        }
        return '';
    }, [
        showLimitTips,
        selectInfo,
        productInfo
    ]);
    (0,react.useEffect)(function() {
        setOpenSizeGuide(false);
        setShowLimitTips(false);
    }, [
        productInfo
    ]);
    var ref12;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !router.isFallback && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo, {
            }),
            (!productInfo || !(selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.id)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:container md:p-10 product-wrapper pb-10 transition-opacity delay-200",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:block w-full bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* ProductSkeleton */.NB, {
                            isPC: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:hidden w-full bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* ProductSkeleton */.NB, {
                        })
                    })
                ]
            }),
            productInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "product",
                "data-title": productInfo === null || productInfo === void 0 ? void 0 : productInfo.title,
                "data-available": moreProductInfo.available,
                "data-spu": moreProductInfo.spu,
                "data-oprice": productInfo === null || productInfo === void 0 ? void 0 : productInfo.variants.edges[0].node.compareAtPrice,
                "data-cprice": productInfo === null || productInfo === void 0 ? void 0 : productInfo.variants.edges[0].node.price,
                className: "lg:container md:p-10 product-wrapper pb-10 opacity-0 transition-opacity delay-200",
                style: {
                    opacity: (selectInfo === null || selectInfo === void 0 ? void 0 : selectInfo.id) ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex w-full clear-both items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-3/5 md:top-40 md:sticky md:float-left",
                                id: "pswiper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products_ProductsSwiper, {
                                    data: productInfo,
                                    initialSlide: swiperIndex
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full md:w-2/5 float-none md:float-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(products_ProductsMeta, {
                                        data: productInfo,
                                        selectInfo: selectInfo,
                                        onShare: function() {
                                            return setOpenShare(true);
                                        },
                                        reviews: reviews,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSelect, {
                                            data: productInfo,
                                            onSelectChange: function(val) {
                                                return onSelectChange(val);
                                            },
                                            onOpenSizeGuide: function() {
                                                return setOpenSizeGuide(true);
                                            },
                                            errorMsg: errorMsg
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBar, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsList, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBar, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfo, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBar, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFooter, {
                                        loading: loading,
                                        canBuy: canBuy,
                                        onAddClick: handleAdd,
                                        forBtn: true,
                                        errorMsg: errorMsg
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModel, {
                                        data: productInfo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBar, {
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsReviewsNew, {
                                        pData: _name_objectSpread({
                                        }, productInfo, moreProductInfo, {
                                            compareAtPrice: +(productInfo === null || productInfo === void 0 ? void 0 : productInfo.variants.edges[0].node.compareAtPrice),
                                            price: +(productInfo === null || productInfo === void 0 ? void 0 : productInfo.variants.edges[0].node.price),
                                            pCover: (ref12 = (ref1 = productInfo === null || productInfo === void 0 ? void 0 : (ref13 = productInfo.images) === null || ref13 === void 0 ? void 0 : ref13.edges[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.node) === null || ref2 === void 0 ? void 0 : ref2.src) !== null && ref12 !== void 0 ? ref12 : ''
                                        }),
                                        pTitle: productInfo === null || productInfo === void 0 ? void 0 : productInfo.title,
                                        pid: productInfo.id,
                                        pHandle: productInfo.handle,
                                        onInit: setReviews
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBar, {
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductShare, {
                        open: openShare,
                        onOpenChange: setOpenShare,
                        data: productInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFooter, {
                        canBuy: canBuy,
                        loading: loading,
                        onAddClick: handleAdd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSizeGuide, {
                        data: productInfo,
                        open: openSizeGuide,
                        onBack: setOpenSizeGuide
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsRecommend, {
                        proudctId: productInfo === null || productInfo === void 0 ? void 0 : productInfo.id,
                        title: "You May Also Like"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToCollection, {
                    })
                ]
            }, productInfo.title)
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var _name_ = (ProductsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,461,837,774,888,179], function() { return __webpack_exec__(35866); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);